"use client";

import { Car, Clock, DollarSign, Phone } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  icon: "dollar",
  title: "Garantált Árak",
  description: "Nincsenek rejtett költségek. Átlátható taxi tarifák a repülőtértől a szállásig, fixen."
}, {
  icon: "car",
  title: "Modern Flotta",
  description: "Utazzon kényelmesen prémium kategóriás autóinkkal, melyeket a maximális komfortra terveztünk."
}, {
  icon: "clock",
  title: "24/7 Ügyelet",
  description: "Éjjel-nappali elérhetőség. Foglaljon bármikor, mi alkalmazkodunk az Ön menetrendjéhez."
}];
export default function DelhiDropping() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="231965" id="carrentaltaxibooking" className="bg-background text-foreground py-20 md:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {}
          <div ref={leftRef} className={`flex flex-col gap-6 transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            {}
            <div>
              <Badge className="px-4 py-1.5 text-sm font-default font-medium tracking-wider uppercase rounded-full border-0 shadow-sm" style={{
              background: `linear-gradient(135deg, var(--primary) 0%, var(--chart-3) 100%)`,
              color: `var(--primary-foreground)`
            }}>
                Travel Concierge
              </Badge>
            </div>

            {}
            <h2 className="font-default text-4xl md:text-5xl lg:text-5xl font-bold leading-tight" style={{
            color: `var(--foreground)`,
            fontFamily: `var(--font-serif)`
          }}>
              Taxi és Transzfer:{" "}
              <span style={{
              color: `var(--primary)`
            }}>Gyors Foglalás</span>{" "}
              Mindenhova
            </h2>

            {}
            <p className="font-default text-base md:text-lg leading-relaxed" style={{
            color: `var(--muted-foreground)`
          }}>
              A TRAVEL segítségével egyszerűen és gyorsan foglalhat taxit vagy transzfert. 
              Legyen szó repülőtéri fuvarról, városi közlekedésről vagy vidéki kiruccanásról — 
              megbízható sofőrjeink és modern járműparkunk garantálják a zökkenőmentes érkezést.
            </p>

            {}
            <div className="flex items-center gap-4 mt-2">
              <div className="h-px flex-1 max-w-16" style={{
              background: `var(--primary)`
            }} />
              <p className="font-default text-sm font-semibold uppercase tracking-widest" style={{
              color: `var(--primary)`
            }}>
                Prémium Szolgáltatás
              </p>
              <div className="h-px flex-1" style={{
              background: `var(--border)`
            }} />
            </div>

            {}
            <div className="mt-4">
              <Button asChild size="lg" className="rounded-full px-8 py-6 text-base font-sans tracking-normal font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105" style={{
              background: `linear-gradient(135deg, var(--primary) 0%, var(--chart-3) 100%)`,
              color: `var(--primary-foreground)`
            }}>
                <Link to="#">
                  <Phone className="size-5 mr-2" />
                  Foglaljon Most
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`flex flex-col gap-5 transition-all duration-700 ease-out delay-200 ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            {features.map((feature, i) => <div data-index={i} key={i} className="relative rounded-2xl p-6 border transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 group" style={{
            background: `color-mix(in srgb, var(--card) 90%, transparent)`,
            backdropFilter: `blur(16px)`,
            WebkitBackdropFilter: `blur(16px)`,
            borderColor: `var(--border)`,
            boxShadow: `var(--shadow-lg)`
          }}>
                {}
                <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" style={{
              background: `linear-gradient(135deg, color-mix(in srgb, var(--primary) 10%, transparent) 0%, transparent 70%)`
            }} />

                <div className="relative flex items-start gap-5">
                  {}
                  <div className="shrink-0 w-12 h-12 rounded-xl flex items-center justify-center shadow-md" style={{
                background: `linear-gradient(135deg, var(--primary) 0%, var(--chart-3) 100%)`
              }}>
                    {feature.icon === "dollar" && <DollarSign className="size-5" style={{
                  color: `var(--primary-foreground)`
                }} />}
                    {feature.icon === "car" && <Car className="size-5" style={{
                  color: `var(--primary-foreground)`
                }} />}
                    {feature.icon === "clock" && <Clock className="size-5" style={{
                  color: `var(--primary-foreground)`
                }} />}
                  </div>

                  {}
                  <div className="flex flex-col gap-1.5">
                    <h3 className="font-default text-lg font-bold" style={{
                  color: `var(--foreground)`
                }}>
                      {feature.title}
                    </h3>
                    <p className="font-default text-sm leading-relaxed" style={{
                  color: `var(--muted-foreground)`
                }}>
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>)}

            {}
            <div className="rounded-2xl p-5 border flex items-center gap-4 shadow-md" style={{
            background: `linear-gradient(135deg, color-mix(in srgb, var(--primary) 10%, var(--accent)) 0%, var(--accent) 100%)`,
            borderColor: `color-mix(in srgb, var(--primary) 20%, transparent)`
          }}>
              <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 shadow-sm" style={{
              background: `var(--primary)`
            }}>
                <Phone className="size-4" style={{
                color: `var(--primary-foreground)`
              }} />
              </div>
              <div>
                <p className="font-default text-sm font-bold" style={{
                color: `var(--accent-foreground)`
              }}>
                  Azonnali Visszaigazolás
                </p>
                <p className="font-default text-xs" style={{
                color: `color-mix(in srgb, var(--accent-foreground) 80%, transparent)`
              }}>
                  Foglalása perceken belül megerősítésre kerül — várakozás nélkül, teljes nyugalommal.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}